const Title = () => (
    <>
    <h1 style={{color: "#793EF9"}} className="text-xl font-semibold text-700 text-center">
        Welcome to Easy ETH Transfer<br/>
    </h1>
    {/* <p className="text-l font-semibold text-gray-700 text-center" style={{color: "lightblue"}}>Ethereum Only</p> */}
    <p className="text-xs font-semibold text-gray-700 text-center" style={{color: "cyan", paddingBottom: "5px"}}>WMouton Ethereum Payment System</p>
    <p className="text-xs font-semibold text-gray-700 text-center" style={{color: "#793EF9", paddingBottom: "20px"}}>Send ETH to anyone in the world!{' '}</p>
    <p className="text-xs font-semibold text-gray-700 text-center" style={{color: "lightblue", paddingBottom: "10px"}}>YOU CAN DONATE TO THE ADDRESS BELOW</p>
    <h6 className="text-xs font-semibold text-gray-700 text-center" style={{color: "cyan"}}>0xc3a05d85F6b2A6B16fCD09987D2eEe221973B1C7</h6>
    <p className="text-xs font-semibold text-gray-700 text-center" style={{color: "lightblue"}}>Every donation is much appreciated. </p>

    </>
)

export default Title;
